<template>
    <b-form-radio-group
            v-model="internalModel"
            stacked
            :class="{'checkmark': checkMarkStyle}"
            class="radio-dropdown"
    >
        <div
                class="radio-item d-flex"
                v-for="(item, index) in options"
                :key="index"
        >
            <label
                    class="custom-control-label mb-0 cursor-pointer"
                    :for="`radio-${index}`"
            >
                <span>
                    {{ item.text }}
                </span>
            </label>
            <b-form-radio
                    :value="item.value"
                    :id="`radio-${index}`"
                    class="ml-auto"
            />
            <i
                    v-if="checkMarkStyle && isEqual(internalModel,item.value)"
                    class="check-icon fas fa-check"
            />
        </div>
    </b-form-radio-group>
</template>

<script>
    import './RadioDropdown.scss';
    import VModel from "@milestoneslabs/milestones-ui-kit/src/mixins/VModel";
    import isEqual from 'lodash/isEqual';

    export default {
        name: "RadioDropdown",
        mixins: [
            VModel
        ],
        props: {
            options: {
                type: Array,
                default: () => {
                    return [];
                }
            },
            checkMarkStyle: {
                type: Boolean,
                default: true
            },
        },
        methods: {
            isEqual
        }
    };
</script>